function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppreciationBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.85,176.35a131.19,131.19,0,0,0-27.45-55.94c-7.21-8.53-16-16.62-26.2-21.87C321.79,82.38,267.63,116.48,241.31,134s-46.05.45-78.36-3.14-71.79,22.44-73.58,63.72,51.15,73.58,40.38,96-26.92,56.53,32.31,69.09S250.9,313,287.69,318.39s30.1,54.39,96,31.41C437.07,331.21,420.5,236.86,406.85,176.35Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.85,176.35a131.19,131.19,0,0,0-27.45-55.94c-7.21-8.53-16-16.62-26.2-21.87C321.79,82.38,267.63,116.48,241.31,134s-46.05.45-78.36-3.14-71.79,22.44-73.58,63.72,51.15,73.58,40.38,96-26.92,56.53,32.31,69.09S250.9,313,287.69,318.39s30.1,54.39,96,31.41C437.07,331.21,420.5,236.86,406.85,176.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-68"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.45,
    cy: 377.75,
    rx: 75.57,
    ry: 10.8,
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.45,
    cy: 377.75,
    rx: 75.57,
    ry: 10.8,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.51,
    cy: 403.13,
    rx: 42.45,
    ry: 10.8,
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.51,
    cy: 403.13,
    rx: 42.45,
    ry: 10.8,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.17,154.5a5.68,5.68,0,0,1,4.56-7.12c4.76-.65,10.61,5.74,12.46,9.61.16.33,2.06,5.85,2,5.85s-8.44.19-11.88-1.31C52.34,160.24,49,157.79,48.17,154.5Zm122.27-14.67c-.7,3.32-4,5.86-6.91,7.22s-9.77,1.6-11.46,1.63c-.91,1.09-1.88,2.25-2.92,3.57-1.82,2.33-3.84,5-5.85,8-.54.81-1.08,1.69-1.63,2.54,1.22-1.24,2.91-2.92,3.09-3.07,3.35-2.67,11.4-5.86,15.4-3.21a5.68,5.68,0,0,1,1,8.4c-2.15,2.62-6.27,3.35-9.47,3.22s-9.6-3.17-11-3.85c-1.18,1.9-2.34,3.88-3.44,6a73.2,73.2,0,0,0-5,12l.24.12c1-1.28,3.1-3.93,3.3-4.13,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9,4.24-3.68.26-11.3-2.62-11.58-2.73a99.36,99.36,0,0,0-2.77,12.69c-.5,3.16-.87,6.39-1.21,9.64.66-.92,3.44-4.4,3.67-4.63,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9,4.24-3.6.25-10.91-2.47-11.52-2.7-.15,1.47-.32,2.94-.46,4.42-.47,4.82-.92,9.66-1.51,14.42-.2,1.65-.47,3.27-.72,4.89,1-1.35,3-3.76,3.16-3.95,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9.05,4.23s-9.41-1.93-11.14-2.56c-.45,2.7-1,5.36-1.57,8-.29,1.12-.51,2.27-.85,3.33s-.64,2.13-1,3.18c-.73,2.14-1.39,4.14-2.12,6.12-.36,1-.72,1.94-1.09,2.91.85-1.52,2.23-3.91,2.39-4.11,2.54-3.45,9.49-8.62,14-7.09a5.68,5.68,0,0,1,3.14,7.85c-1.4,3.09-5.19,4.85-8.31,5.56-3.44.78-10.83-.72-11.74-.91-.9,2.37-1.79,4.67-2.67,6.81-2.77,6.76-5.33,12.3-7.18,16.14-.1.22-.2.41-.3.62h13.47l-4.65,90.67A13,13,0,0,1,103.85,382h0a13,13,0,0,1-12.95-12.3L86.26,279h14.45c-.07-.63-.14-1.29-.23-2-.48-4.19-1.26-10.18-2.52-17.31-.35-2.06-.77-4.23-1.21-6.46-.94.12-8.4,1.06-11.77,0-3.07-.94-6.71-3-7.87-6.16a5.68,5.68,0,0,1,3.71-7.6c4.65-1.19,11.2,4.48,13.48,8.12.14.23,1.56,3.17,2.25,4.69-.27-1.35-.54-2.69-.85-4.09-.43-2-1-4.13-1.44-6.18-.3-1.05-.59-2.12-.89-3.19s-.68-2.1-1-3.17c-.53-1.55-1.16-3.13-1.78-4.7-2,.56-8,2.1-11.06,1.66s-7.08-1.93-8.71-4.9a5.69,5.69,0,0,1,2.52-8.08c4.42-1.87,11.74,2.74,14.55,6,.09.1.61.85,1.22,1.74-.65-1.52-1.3-3-2-4.55-2-4.3-4.21-8.62-6.39-13-.45-.9-.89-1.81-1.34-2.72-1.71.48-8.16,2.21-11.37,1.74s-7.08-1.93-8.71-4.9a5.67,5.67,0,0,1,2.52-8.07c4.41-1.88,11.74,2.74,14.55,6,.1.12.72,1,1.41,2-1.15-2.38-2.27-4.76-3.31-7.15a102,102,0,0,1-4.56-12.63c-.6.18-8.12,2.36-11.69,1.84-3.17-.46-7.08-1.93-8.71-4.9A5.67,5.67,0,0,1,52,173c4.42-1.88,11.74,2.74,14.55,6,.2.23,2.42,3.48,3.18,4.66a.88.88,0,0,1,0-.15,73.59,73.59,0,0,1-2.18-13,99,99,0,0,1-.28-11.78c.08-3.64.38-7,.68-9.91.17-1.6.35-3.05.54-4.4l-.08.05c-.08,0-1.69-5.55-1.75-5.92-.71-4.23.42-12.82,4.68-15a5.67,5.67,0,0,1,7.82,3.21c1.25,3.15-.11,7.1-1.78,9.84s-7.26,6.72-8.65,7.67c-.17,1.41-.33,2.92-.47,4.6-.23,2.94-.46,6.26-.47,9.89,0,1,0,2,.05,3,.33-1.7.81-4,.88-4.26,1.32-4.08,6.27-11.18,11.08-11.18a5.69,5.69,0,0,1,5.46,6.46c-.35,3.37-3.38,6.25-6.12,7.91s-9.76,2.65-11.27,2.83c.06,2.24.19,4.53.45,6.92a73.66,73.66,0,0,0,2.45,12.82l.27,0c.11-1.61.42-5,.47-5.27.87-4.2,5-11.8,9.79-12.32a5.69,5.69,0,0,1,6.14,5.82c0,3.39-2.68,6.58-5.22,8.53C79.25,182.19,71.31,184,71,184.06a99.29,99.29,0,0,0,4.69,12.11C77,199.08,78.5,202,80,204.88c0-1.14.44-5.57.51-5.89.87-4.2,5-11.8,9.78-12.32a5.68,5.68,0,0,1,6.14,5.81c0,3.39-2.67,6.58-5.21,8.53-2.86,2.2-10.46,4-11.1,4.11.69,1.31,1.36,2.63,2.06,3.94,2.27,4.28,4.56,8.56,6.69,12.86.74,1.49,1.42,3,2.1,4.48.12-1.7.41-4.78.46-5.05.87-4.19,5-11.8,9.78-12.32a5.69,5.69,0,0,1,6.14,5.82c0,3.39-2.67,6.58-5.21,8.53s-8.91,3.58-10.71,4c1.12,2.49,2.17,5,3.09,7.5.37,1.09.82,2.18,1.12,3.25l1,3.17c.58,2.19,1.13,4.22,1.61,6.28.26,1,.47,2,.7,3-.13-1.73-.29-4.49-.28-4.74.22-4.28,3.16-12.43,7.8-13.66a5.67,5.67,0,0,1,7,4.82,6.51,6.51,0,0,1,.08,1.25,22.2,22.2,0,0,1,3,10.74c0,.27-.45,3.51-.71,5.15.52-1.27,1-2.54,1.54-3.87.75-1.92,1.49-4,2.21-6,.33-1,.67-2.1,1-3.16s.59-2.13.89-3.2c.42-1.59.77-3.25,1.12-4.91-2-.64-7.83-2.65-10.14-4.71s-4.84-5.52-4.57-8.9a5.69,5.69,0,0,1,6.56-5.34c4.72.87,8.28,8.76,8.84,13,0,.13,0,1,0,2.13.3-1.63.6-3.25.84-4.91.69-4.7,1.24-9.52,1.82-14.33.11-1,.25-2,.37-3-1.68-.54-8-2.66-10.44-4.82s-4.84-5.52-4.56-8.89a5.68,5.68,0,0,1,6.55-5.35c4.73.87,8.29,8.77,8.84,13,0,.15,0,1.24.06,2.46.35-2.62.74-5.22,1.19-7.79a101.33,101.33,0,0,1,3.16-13c-.59-.19-8.07-2.52-10.76-4.92-2.39-2.14-4.84-5.52-4.57-8.9a5.69,5.69,0,0,1,6.56-5.34c4.72.87,8.28,8.76,8.84,13,0,.3.1,4.23.07,5.64l0-.15a74.78,74.78,0,0,1,5.34-12,101.28,101.28,0,0,1,6.27-10c2.08-3,4.17-5.6,6-7.89,1-1.24,2-2.35,2.88-3.38h-.11c-.08,0,1.67-5.57,1.82-5.91,1.74-3.91,7.41-10.46,12.19-9.94A5.67,5.67,0,0,1,170.44,139.83ZM115.37,255.05c-.81-.4-7.11-3.52-9.57-6.18A60.8,60.8,0,0,1,99.24,252c.56,2.47,1.08,4.89,1.52,7.16,1.43,7.17,2.34,13.19,2.92,17.42.13.9.23,1.71.33,2.44h.32l1-2.05c1.91-3.76,4.56-9.18,7.45-15.82C113.66,259.2,114.52,257.15,115.37,255.05Zm25.16-91.67c.08.05,1.53-5.6,1.59-6,.59-4.25-.77-12.8-5.09-14.89A5.68,5.68,0,0,0,129.3,146c-1.16,3.18.31,7.09,2,9.78C133.39,158.89,140.53,163.38,140.53,163.38Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,154.5a5.68,5.68,0,0,1,4.56-7.12c4.76-.65,10.61,5.74,12.46,9.61.16.33,2.06,5.85,2,5.85s-8.44.19-11.88-1.31C52.34,160.24,49,157.79,48.17,154.5Zm122.27-14.67c-.7,3.32-4,5.86-6.91,7.22s-9.77,1.6-11.46,1.63c-.91,1.09-1.88,2.25-2.92,3.57-1.82,2.33-3.84,5-5.85,8-.54.81-1.08,1.69-1.63,2.54,1.22-1.24,2.91-2.92,3.09-3.07,3.35-2.67,11.4-5.86,15.4-3.21a5.68,5.68,0,0,1,1,8.4c-2.15,2.62-6.27,3.35-9.47,3.22s-9.6-3.17-11-3.85c-1.18,1.9-2.34,3.88-3.44,6a73.2,73.2,0,0,0-5,12l.24.12c1-1.28,3.1-3.93,3.3-4.13,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9,4.24-3.68.26-11.3-2.62-11.58-2.73a99.36,99.36,0,0,0-2.77,12.69c-.5,3.16-.87,6.39-1.21,9.64.66-.92,3.44-4.4,3.67-4.63,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9,4.24-3.6.25-10.91-2.47-11.52-2.7-.15,1.47-.32,2.94-.46,4.42-.47,4.82-.92,9.66-1.51,14.42-.2,1.65-.47,3.27-.72,4.89,1-1.35,3-3.76,3.16-3.95,3-3,10.69-7.08,15-4.88a5.68,5.68,0,0,1,1.91,8.24c-1.85,2.84-5.86,4-9.05,4.23s-9.41-1.93-11.14-2.56c-.45,2.7-1,5.36-1.57,8-.29,1.12-.51,2.27-.85,3.33s-.64,2.13-1,3.18c-.73,2.14-1.39,4.14-2.12,6.12-.36,1-.72,1.94-1.09,2.91.85-1.52,2.23-3.91,2.39-4.11,2.54-3.45,9.49-8.62,14-7.09a5.68,5.68,0,0,1,3.14,7.85c-1.4,3.09-5.19,4.85-8.31,5.56-3.44.78-10.83-.72-11.74-.91-.9,2.37-1.79,4.67-2.67,6.81-2.77,6.76-5.33,12.3-7.18,16.14-.1.22-.2.41-.3.62h13.47l-4.65,90.67A13,13,0,0,1,103.85,382h0a13,13,0,0,1-12.95-12.3L86.26,279h14.45c-.07-.63-.14-1.29-.23-2-.48-4.19-1.26-10.18-2.52-17.31-.35-2.06-.77-4.23-1.21-6.46-.94.12-8.4,1.06-11.77,0-3.07-.94-6.71-3-7.87-6.16a5.68,5.68,0,0,1,3.71-7.6c4.65-1.19,11.2,4.48,13.48,8.12.14.23,1.56,3.17,2.25,4.69-.27-1.35-.54-2.69-.85-4.09-.43-2-1-4.13-1.44-6.18-.3-1.05-.59-2.12-.89-3.19s-.68-2.1-1-3.17c-.53-1.55-1.16-3.13-1.78-4.7-2,.56-8,2.1-11.06,1.66s-7.08-1.93-8.71-4.9a5.69,5.69,0,0,1,2.52-8.08c4.42-1.87,11.74,2.74,14.55,6,.09.1.61.85,1.22,1.74-.65-1.52-1.3-3-2-4.55-2-4.3-4.21-8.62-6.39-13-.45-.9-.89-1.81-1.34-2.72-1.71.48-8.16,2.21-11.37,1.74s-7.08-1.93-8.71-4.9a5.67,5.67,0,0,1,2.52-8.07c4.41-1.88,11.74,2.74,14.55,6,.1.12.72,1,1.41,2-1.15-2.38-2.27-4.76-3.31-7.15a102,102,0,0,1-4.56-12.63c-.6.18-8.12,2.36-11.69,1.84-3.17-.46-7.08-1.93-8.71-4.9A5.67,5.67,0,0,1,52,173c4.42-1.88,11.74,2.74,14.55,6,.2.23,2.42,3.48,3.18,4.66a.88.88,0,0,1,0-.15,73.59,73.59,0,0,1-2.18-13,99,99,0,0,1-.28-11.78c.08-3.64.38-7,.68-9.91.17-1.6.35-3.05.54-4.4l-.08.05c-.08,0-1.69-5.55-1.75-5.92-.71-4.23.42-12.82,4.68-15a5.67,5.67,0,0,1,7.82,3.21c1.25,3.15-.11,7.1-1.78,9.84s-7.26,6.72-8.65,7.67c-.17,1.41-.33,2.92-.47,4.6-.23,2.94-.46,6.26-.47,9.89,0,1,0,2,.05,3,.33-1.7.81-4,.88-4.26,1.32-4.08,6.27-11.18,11.08-11.18a5.69,5.69,0,0,1,5.46,6.46c-.35,3.37-3.38,6.25-6.12,7.91s-9.76,2.65-11.27,2.83c.06,2.24.19,4.53.45,6.92a73.66,73.66,0,0,0,2.45,12.82l.27,0c.11-1.61.42-5,.47-5.27.87-4.2,5-11.8,9.79-12.32a5.69,5.69,0,0,1,6.14,5.82c0,3.39-2.68,6.58-5.22,8.53C79.25,182.19,71.31,184,71,184.06a99.29,99.29,0,0,0,4.69,12.11C77,199.08,78.5,202,80,204.88c0-1.14.44-5.57.51-5.89.87-4.2,5-11.8,9.78-12.32a5.68,5.68,0,0,1,6.14,5.81c0,3.39-2.67,6.58-5.21,8.53-2.86,2.2-10.46,4-11.1,4.11.69,1.31,1.36,2.63,2.06,3.94,2.27,4.28,4.56,8.56,6.69,12.86.74,1.49,1.42,3,2.1,4.48.12-1.7.41-4.78.46-5.05.87-4.19,5-11.8,9.78-12.32a5.69,5.69,0,0,1,6.14,5.82c0,3.39-2.67,6.58-5.21,8.53s-8.91,3.58-10.71,4c1.12,2.49,2.17,5,3.09,7.5.37,1.09.82,2.18,1.12,3.25l1,3.17c.58,2.19,1.13,4.22,1.61,6.28.26,1,.47,2,.7,3-.13-1.73-.29-4.49-.28-4.74.22-4.28,3.16-12.43,7.8-13.66a5.67,5.67,0,0,1,7,4.82,6.51,6.51,0,0,1,.08,1.25,22.2,22.2,0,0,1,3,10.74c0,.27-.45,3.51-.71,5.15.52-1.27,1-2.54,1.54-3.87.75-1.92,1.49-4,2.21-6,.33-1,.67-2.1,1-3.16s.59-2.13.89-3.2c.42-1.59.77-3.25,1.12-4.91-2-.64-7.83-2.65-10.14-4.71s-4.84-5.52-4.57-8.9a5.69,5.69,0,0,1,6.56-5.34c4.72.87,8.28,8.76,8.84,13,0,.13,0,1,0,2.13.3-1.63.6-3.25.84-4.91.69-4.7,1.24-9.52,1.82-14.33.11-1,.25-2,.37-3-1.68-.54-8-2.66-10.44-4.82s-4.84-5.52-4.56-8.89a5.68,5.68,0,0,1,6.55-5.35c4.73.87,8.29,8.77,8.84,13,0,.15,0,1.24.06,2.46.35-2.62.74-5.22,1.19-7.79a101.33,101.33,0,0,1,3.16-13c-.59-.19-8.07-2.52-10.76-4.92-2.39-2.14-4.84-5.52-4.57-8.9a5.69,5.69,0,0,1,6.56-5.34c4.72.87,8.28,8.76,8.84,13,0,.3.1,4.23.07,5.64l0-.15a74.78,74.78,0,0,1,5.34-12,101.28,101.28,0,0,1,6.27-10c2.08-3,4.17-5.6,6-7.89,1-1.24,2-2.35,2.88-3.38h-.11c-.08,0,1.67-5.57,1.82-5.91,1.74-3.91,7.41-10.46,12.19-9.94A5.67,5.67,0,0,1,170.44,139.83ZM115.37,255.05c-.81-.4-7.11-3.52-9.57-6.18A60.8,60.8,0,0,1,99.24,252c.56,2.47,1.08,4.89,1.52,7.16,1.43,7.17,2.34,13.19,2.92,17.42.13.9.23,1.71.33,2.44h.32l1-2.05c1.91-3.76,4.56-9.18,7.45-15.82C113.66,259.2,114.52,257.15,115.37,255.05Zm25.16-91.67c.08.05,1.53-5.6,1.59-6,.59-4.25-.77-12.8-5.09-14.89A5.68,5.68,0,0,0,129.3,146c-1.16,3.18.31,7.09,2,9.78C133.39,158.89,140.53,163.38,140.53,163.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.08,386.26a88.29,88.29,0,0,1-11.42,7.07c-4.71,2.17-5.62,2.17-5.44,3.44s5.62,3.26,15.59.91,14.68-1.82,16.13-6.53-.9-3.44-3.8-3.44A106,106,0,0,1,396.08,386.26Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.4,392.4c-4.25,1.12-11.91,3-18.31,4a28.55,28.55,0,0,1-12.64-.56,1,1,0,0,0-.23.92c.18,1.27,5.62,3.26,15.59.91C403.79,395.56,408.49,395.77,410.4,392.4Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,299.71s.37,6.35-4,15.05-17.19,9.42-20.63,9.42-2.36-3.62-2.36-3.62l.54-3.27-5.8-1.45s-15.4,20.49-15.4,22.12,15.92,39.05,16.83,43.4,1.45,5.44-.55,7.07a11.83,11.83,0,0,1-10.33,1.63,45.37,45.37,0,0,1-7.79-3.26,39.37,39.37,0,0,1,0-4.89c.18-1.63,2.9-.36,1.63-3.08s-2-3.45-2.72-5.26-17.87-30.39-17.14-37.1,16.81-30,16.81-30.54a43.07,43.07,0,0,1,2.35-4.95s.72-2.36,2.54-2.72,29.54,0,36.61-.9S446.1,296.81,445,299.71Z",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.81,
    y1: 351.17,
    x2: 400.84,
    y2: 353.36,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05,326.3l-7.82,10.22s-10,1.21-7,1.41,6,.2,6,.2-2.61.8-2,1.2a5.64,5.64,0,0,0,2.21.4l4.27,9.08",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,223.4s-2.53,1.4-6.34,3.57-6,3.26-6.52,5.08-11.61,24.52-11.61,24.52,4.35,2.54,8.34,4.35a45.1,45.1,0,0,0,9.42,2.72l3.63-7.61s7,13.22,10,17.94c5.34,8.43,3.62,13.6,2.9,16.5s-2.72,8.34-2.18,9.06,14.68,7.07,23.75,6.53,24.61-1.38,25.7-2.65,1.27-8.59,1.27-9.14-1.6-14.68-3.23-23.2-10.51-31.36-13.41-37.52-5.62-8.16-13-10.69-18.31-3.08-22.84-2.54S387.77,223.4,387.77,223.4Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "418.28 247.71 429.51 251.32 420.09 252.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,276.38s10.82,8.82,24.06,8.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.45,284.4s9,4.21,18.24,2.81",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "380.19 244.91 384.69 256.03 375.18 242.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,224.67a34.33,34.33,0,0,0-.18,6.16c.18,3.81,1.45,6.53.36,9.25s.19,4,1.27,2.72,2.9-6.17,3.27-7.07,8-2.54,9.06-2.54,4.53,5.44,6.16,6.16,1.27-.72.18-3.62-2.35-13-4.89-16.14S389.58,217.24,387,224.67Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,227.93c-1-.35,5.25,9.25,7.79,14.14s4.89,3.63,5.26-.18-1.27-16.5-1.27-16.5S394.11,229.75,388.86,227.93Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.84,237.33a12.49,12.49,0,0,1-7.42.76c.85,1.46,1.64,2.85,2.23,4,2.54,4.89,4.89,3.63,5.26-.18A34.56,34.56,0,0,0,401.84,237.33Z",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.16,
    y1: 304.85,
    x2: 407.16,
    y2: 327.26,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.38,309.9a1.62,1.62,0,0,1-.31,0l-33.71-4a2.62,2.62,0,0,1,.61-5.2l33.71,4a2.61,2.61,0,0,1-.3,5.21Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.53,
    cy: 307.15,
    rx: 1.63,
    ry: 1.92,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,403.61l20.21,9.95a.91.91,0,0,0,.74,0L429,409.07a.93.93,0,0,0,.06-1.72l-18.94-8.77a.94.94,0,0,0-.62-.06l-13.38,3.35A.93.93,0,0,0,395.92,403.61Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,406.92h-4a3.44,3.44,0,0,1-3.43-3.43l-2.51-73.3a3.11,3.11,0,0,1,3.11-3.11h4.65a3.11,3.11,0,0,1,3.11,3.11l2.51,73.3A3.43,3.43,0,0,1,412,406.92Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.82,404.38a104.57,104.57,0,0,1-9.61,8c-4,2.72-4.35,2.36-3.44,4.17s3.62,2.9,11.24,1.27,10.15-2.9,14.32-5.26,5.43-2.36,4.35-3.81S421.82,404.38,421.82,404.38Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.33,412.54c4.16-2.36,5.43-2.36,4.35-3.81a2.69,2.69,0,0,0-1-.59,92.39,92.39,0,0,1-17.46,8c-7.8,2.35-11.6-.37-11.6-.37l-.09.15a5.6,5.6,0,0,0,.27.58c.9,1.81,3.62,2.9,11.24,1.27S430.16,414.9,434.33,412.54Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.48,259.47a90.23,90.23,0,0,1-3.44-8.7C444,252.22,434.71,260,434.71,260l8.16,11.05s-7.79,11.24-11.42,17.59a51.08,51.08,0,0,1-9.79,11.6l-8.91-.11a3.07,3.07,0,0,0-1.41,2.29c0,1.4-1.58,6.33-.88,7.21s4.93,1.05,4.93,1.05,6.86.71,8.09-1.05c0,0-2.11-2.29-1.94-3.34s2.29-1.76,2.29-1.76l2.3-.17s.79.55,1.45-3c1.78-1.18,8.25-5.52,11.67-8.94,4-4,15.77-17.22,16.67-19.76S452.84,264.73,450.48,259.47Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.64,257.54c-1.77-4.15-2.6-6.77-2.6-6.77C444,252.22,434.71,260,434.71,260l3.88,5.25A24,24,0,0,0,449.64,257.54Z",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,246.42l9.61,17,5.62-3.81a40.24,40.24,0,0,0,8.34-8.33,145.73,145.73,0,0,0-13.05-17.59c-7.62-8.7-11.24-9.24-14.5-9.06",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.14,305.43c0-.71-3-8.09-3-8.09l-9-4.95c-3.71-7.46-9.41-19.4-10.39-21.5a29.36,29.36,0,0,1-1.82-4.53l1.53-3.26a38.35,38.35,0,0,1-6.78-2.18c-1.69-.76-3.43-1.65-4.88-2.43-.8,3.06-2.17,8.33-1.65,10.95s12.35,17.6,18.26,25.17c0,0,2.47,10.47,3.53,12.05l1.06,1.58s1.75,1.94,2.63,1.76a7.39,7.39,0,0,0,2.11-1.06,4.39,4.39,0,0,0,1.94.18,7,7,0,0,0,2.28-1.58s.88,1,3,.53S401.14,306.13,401.14,305.43Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.7,262.84A25,25,0,0,0,377.07,267c-.13-.39-.18-.59-.18-.59l1.53-3.26a38.35,38.35,0,0,1-6.78-2.18c-1.69-.76-3.43-1.65-4.88-2.43C366.44,259.7,366,261.24,365.7,262.84Z",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,310.84v-6.12",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.43,392.37l-7.57,1.26s-4.62,1.26-5.46,5.46C392.38,409.2,381.92,413,373,415a285.11,285.11,0,0,1-38.33,6.15c-19.68,1.75-39.67,1.42-59.16-2-11.19-2-28.25-4.16-36.59-12.68a5.67,5.67,0,0,1-1.54-2.36c-.67-2.46,1.61-4.7,3.81-6A52.43,52.43,0,0,1,254,393.28c11.45-3.14,25.75-3.74,36.42-8.72,3.12-1.45,5-3.77,1.82-6.57-9.9-8.77-56.24-10.32-56.24-26.81V310.84",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.68,215.53a20.27,20.27,0,0,0-1.86-5.45c-1.24-2.11-4.65-5.51-5.27-8.73s4.16-7,4.16-7-2.61,0-2-1.12,3.6-.62,3.6-.62a3.6,3.6,0,0,1,.62-3.47c1.36-1.61,1.86,1.49,1.86,1.49a17.91,17.91,0,0,1,6.57-7.31c4.46-2.61,12.4,1,13.27,3.22S399.4,188,399.4,188s10.66,4.83,11.4,12-5.45,5.95-5.45,5.95.37,4.22-.5,5.71-1.24,2-5.58-1.49-13.26-2.23-13.76.5-2,6.81-4.21,6.32S379.68,215.53,379.68,215.53Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,199.2s-4.29-3.7.39-4.47,6.42,7.59,11.29,9.34a12.1,12.1,0,0,0,9.15-.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.08,198.55s-4.91-3.2-4.49-5.34,8.34-4.92,12.61-2.35,4.49,7.91,9.83,9.19,4.49-1.71,3.85-2.57",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.68,202.19c-.86-1.07-1.07-5.13,2.35-5.77s6.2,3,6.2,3c-.65.42-4.49,1.49-5.13,4.7s2.56,3.2,1.07,6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3,215.61s-.18-.23-.45-.51c-.66-.68-2.52-1.17-3.09.19-.8,1.93,1.38,5.59,3,6.07a2.84,2.84,0,0,0,2.64-.45s4.46,9,10.07,11.11,8.38-4.53,10.15-9,1.12-6.09,1.12-6.09,3,.71,3.93-2.82-.56-4.88-1.52-4.72a10.22,10.22,0,0,0-2.57,1.12l-1.44-3.85s-2.73,1.61-7.38-.16-6.9-6.09-8-5.77-1,3.2-1,3.2-2.08-1.12-2.88-.16,1.28,2.09.32,5.62S381.1,214,381.1,214s.8,1.6.16,1.6Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.58,213.26c.15.68-.05,1.29-.43,1.37s-.82-.39-1-1.07.05-1.29.44-1.37S389.44,212.59,389.58,213.26Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.27,212.38c0,.69-.28,1.27-.68,1.28s-.73-.54-.75-1.23.27-1.26.67-1.27S397.24,211.69,397.27,212.38Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.53,211.09a4.16,4.16,0,0,1,3.27-2.52",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.15,208.11a3.8,3.8,0,0,1,3.92,1.4",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.45,222.39s-5.5,2.05-8.21-1.78",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,222.3s.19,3.73,2.15,4.48,2.89-4,2.89-4A10.58,10.58,0,0,1,390,222.3Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45,224.57a3.36,3.36,0,0,0,1.71,2.21c1,.39,1.77-.74,2.25-1.9A7,7,0,0,0,390.45,224.57Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,209.41a11.6,11.6,0,0,0-.1,6.16c.94,2.9,2.34,3,1.78,3.36s-3,.84-3.55.38",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.65,313.5S407.34,338.14,407,343.58s15.2,51.92,15.56,53.92-2.53,1.63-2.53,3.62a10.61,10.61,0,0,0,.9,4c.18.54,14.5,4.89,16.86,5.07s3.44-.36,3.44-2-1.08-6.71-1.08-7.25,2.9-4,1.81-8.88S430.73,356.27,429.46,353s-2.72-6.7-2.72-6.7a6.77,6.77,0,0,0,1.09-2.72,9.81,9.81,0,0,0,0-2.54s15.71-25.17,15.73-33",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.65,365.61c4.1,12.86,8.94,28.17,9.28,30.45.6,4-.6,4.82-.2,6.82s1.2,4.81,1.2,4.81",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.72,311c-3.12,7.61-8.86,21.65-10,24.54-1.61,4-4.42,7.22-3.81,7.62s2.2.4,1,1.8-2,1.81-2,2.41c0,.21,1.84,5.95,4.22,13.42",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,306.05l-1,2.51",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.78,310.17s.58-6.43,1.17-7.21",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.46,303s-2.58,8.27-2.07,7.74",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,303.54l-1.17,6.24s-.2.59,1.56.78",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.92,
    y1: 307.54,
    x2: 395.82,
    y2: 306.27,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.7,
    y1: 308.94,
    x2: 391.72,
    y2: 308.22,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.59,
    y1: 310,
    x2: 389.19,
    y2: 307.83,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Balloon--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330,284.67a124.91,124.91,0,0,0,16.39-22.28",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,324.2a123.6,123.6,0,0,0,76.56-34.95",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.44,323.27a120.89,120.89,0,0,0,12.1,1.2",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,309q3.85,2,7.81,3.73",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.52,210.12a124.36,124.36,0,0,0,59.63,95.26",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,99a124.32,124.32,0,0,0-122-11",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.44,150.55q-1.85-4.2-4-8.22",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,286.8a111.84,111.84,0,0,0,18.23-17",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,308.39a111.51,111.51,0,0,0,73.7-18.27",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,302.82q5.14,1.77,10.53,3.07",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,229.19q1.13,3.75,2.51,7.4",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,124.22a112.19,112.19,0,0,0-23.94,98.52",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89,95.5a112.1,112.1,0,0,0-110.15,9",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.91,156.12a112.38,112.38,0,0,0-47.46-55.61",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.74,171.6c-.62-2.69-1.35-5.34-2.17-7.95",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14,198.21c0-1.32,1.18-2.66,1.13-4s-1.33-2.57-1.42-3.87,1-2.74.84-4-1.52-2.46-1.71-3.76.78-2.8.53-4.09-1.69-2.34-2-3.62.56-2.85.23-4.12-1.87-2.2-2.26-3.46.35-2.89-.08-4.12-2-2.06-2.51-3.28.13-2.91-.39-4.11-2.18-1.9-2.75-3.08-.09-2.91-.7-4.07-2.31-1.72-3-2.86-.3-2.89-1-4-2.44-1.55-3.18-2.63-.52-2.86-1.3-3.92-2.54-1.36-3.36-2.39-.73-2.81-1.59-3.81-2.64-1.17-3.53-2.13-.94-2.75-1.87-3.68-2.72-1-3.68-1.87-1.14-2.67-2.13-3.53-2.79-.77-3.81-1.59-1.34-2.58-2.39-3.36-2.83-.56-3.92-1.3-1.52-2.48-2.64-3.18-2.86-.34-4-1-1.7-2.35-2.86-3-2.89-.13-4.07-.7-1.87-2.22-3.08-2.75-2.88.09-4.11-.39-2-2.07-3.28-2.51-2.86.31-4.12-.08-2.19-1.91-3.46-2.25-2.83.52-4.12.22-2.32-1.74-3.62-2-2.78.73-4.09.53-2.44-1.56-3.75-1.71-2.73.94-4,.84-2.56-1.37-3.88-1.42-2.64,1.14-4,1.14-2.65-1.19-4-1.14-2.57,1.33-3.88,1.42-2.73-1-4-.84-2.46,1.52-3.75,1.71-2.8-.78-4.09-.53-2.34,1.69-3.62,2-2.85-.56-4.12-.22-2.21,1.86-3.46,2.25-2.89-.35-4.13.08-2,2-3.27,2.51-2.91-.13-4.11.39-1.9,2.18-3.08,2.75-2.91.09-4.07.7-1.73,2.31-2.86,3-2.9.31-4,1-1.55,2.43-2.63,3.17-2.86.52-3.92,1.3-1.36,2.54-2.39,3.37-2.81.72-3.81,1.58-1.17,2.64-2.13,3.53-2.75.94-3.68,1.87-1,2.72-1.87,3.68S157.7,128,156.84,129s-.77,2.78-1.59,3.81-2.58,1.33-3.36,2.39-.56,2.83-1.3,3.91-2.48,1.52-3.18,2.64-.34,2.86-1,4-2.36,1.7-3,2.87-.13,2.88-.7,4.06-2.22,1.88-2.75,3.08.09,2.88-.39,4.11-2.08,2-2.51,3.28.3,2.86-.08,4.12-1.92,2.19-2.26,3.46.52,2.84.23,4.12-1.74,2.32-2,3.62.74,2.79.54,4.09-1.56,2.44-1.71,3.76.94,2.72.84,4-1.38,2.55-1.42,3.87,1.13,2.65,1.13,4-1.18,2.65-1.13,4,1.33,2.57,1.42,3.88-1,2.73-.84,4,1.52,2.46,1.71,3.75-.78,2.81-.54,4.1,1.7,2.33,2,3.61-.57,2.86-.23,4.12,1.87,2.21,2.26,3.46-.35,2.89.08,4.13,2,2.05,2.51,3.28-.13,2.9.39,4.1,2.18,1.9,2.75,3.08.08,2.91.7,4.07,2.31,1.73,3,2.87.3,2.89,1,4,2.44,1.55,3.18,2.63.52,2.86,1.3,3.92,2.54,1.36,3.36,2.39.73,2.82,1.59,3.81,2.64,1.17,3.53,2.14.94,2.75,1.87,3.68,2.72,1,3.68,1.86,1.14,2.68,2.13,3.53,2.78.77,3.81,1.59,1.34,2.58,2.39,3.36,2.83.56,3.92,1.3,1.52,2.48,2.64,3.18,2.86.34,4,1,1.7,2.36,2.86,3,2.88.13,4.07.7,1.87,2.22,3.08,2.75,2.88-.09,4.11.39,2,2.08,3.28,2.51,2.86-.3,4.12.08,2.19,1.92,3.46,2.26,2.83-.52,4.12-.23,2.32,1.74,3.62,2,2.78-.74,4.09-.54,2.44,1.56,3.75,1.71,2.73-.94,4-.84,2.56,1.38,3.88,1.43,2.64-1.14,4-1.14,2.66,1.18,4,1.14,2.57-1.33,3.87-1.43,2.74,1,4,.84,2.46-1.52,3.76-1.71,2.8.78,4.09.54,2.34-1.7,3.62-2,2.85.57,4.12.23,2.21-1.87,3.46-2.26,2.89.35,4.13-.08,2.05-2,3.27-2.51,2.91.14,4.11-.39,1.9-2.18,3.08-2.75,2.91-.08,4.07-.7,1.73-2.31,2.86-3,2.89-.3,4-1,1.55-2.44,2.63-3.18,2.86-.52,3.92-1.3,1.36-2.54,2.39-3.36,2.81-.73,3.81-1.59,1.17-2.64,2.13-3.53,2.75-.94,3.68-1.87,1-2.71,1.87-3.68,2.67-1.14,3.53-2.13.77-2.78,1.59-3.81,2.58-1.33,3.36-2.39.56-2.83,1.3-3.92,2.48-1.52,3.18-2.63.34-2.87,1-4,2.35-1.7,3-2.86.13-2.88.7-4.07,2.22-1.87,2.75-3.08-.09-2.88.39-4.11,2.07-2,2.51-3.27-.31-2.87.08-4.13,1.92-2.18,2.26-3.46-.52-2.83-.23-4.12,1.74-2.32,2-3.61-.73-2.79-.53-4.1,1.56-2.44,1.71-3.75-.94-2.73-.84-4,1.37-2.56,1.42-3.88S342.14,199.53,342.14,198.21Z",
    style: {
      fill: "#263F8C",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.84,
    y1: 98.36,
    x2: 207.69,
    y2: 103.54,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.8,
    y1: 101.14,
    x2: 200.47,
    y2: 105.21,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,145.94a35.45,35.45,0,0,1-10.18,6.11",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.35,152.79a47.86,47.86,0,0,1-4.26,2.4",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,285s4.44-5,5.18-8.7",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.29,274.78s3.71-4.62,4.45-5.36",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.45,
    y1: 299.96,
    x2: 258.97,
    y2: 291.82,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.59,
    y1: 298.3,
    x2: 267.48,
    y2: 293.67,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.47,
    y1: 279.97,
    x2: 296.18,
    y2: 272.93,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.09,
    y1: 243.68,
    x2: 322.65,
    y2: 238.69,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.08,
    y1: 198.33,
    x2: 141.04,
    y2: 198.51,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.37,
    y1: 198.7,
    x2: 148.26,
    y2: 198.88,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,244.24c.93-.37,7-2,7-2",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,96.08c-.56,1.12-1.68,7.57-1.68,7.57",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.79,
    y1: 98.6,
    x2: 266.95,
    y2: 102.81,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.65,
    y1: 112.33,
    x2: 294.41,
    y2: 115.13,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.4,
    y1: 139.23,
    x2: 156,
    y2: 142.31,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.37,
    y1: 143.99,
    x2: 163.85,
    y2: 146.51,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,167.64s-1.71-2.65-10.35-8.1-31-10.63-39.81-15.39c-8.81-4.91-18.63-14.17-22.06-18.62s-2.9-7.81-5.66-8.08-5.52,1-7.44,6.78.43,20.26,2,24.71,6.18,7.27,9.11,8.45,9.48,4.29,9.47,7.08-.36,3.34-1.57,3.55-27.81,4.15-31.91,5.34-5.87,8.66-4.7,14.55,5.81,7.74,4.41,11.92-3.81,9.08-1.43,14.63,6.85,4.69,5.11,9-1.76,9.35.46,12.59,5.15,5.34,5.13,9.27,6.84,12.58,11.15,13.81c2.13.64,21.47,2.76,40.3,2.95,18.82.48,37.13-1,37.1-1Q266.54,214.33,266.89,167.64Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.47,258.16q-16.8,2.54-33.72,3.74a5.21,5.21,0,0,1-5.43-5.52q.17-42.21.34-84.38a5.52,5.52,0,0,1,5.48-5.73q16.92.48,33.72,1.37a5.8,5.8,0,0,1,5.39,5.76q-.18,39.19-.35,78.44A6.62,6.62,0,0,1,304.47,258.16Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,251.83a3.93,3.93,0,0,0-4.13-4.12,4.67,4.67,0,0,0-4.17,4.71,3.92,3.92,0,0,0,4.13,4.15A4.75,4.75,0,0,0,279.43,251.83Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.54,
    cy: 137.26,
    r: 20.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.11,
    cy: 161.71,
    r: 7.46,
    transform: "translate(-27.91 256.04) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,299.65c1.26.09,2.46,1.33,3.74,1.38s2.56-1.1,3.83-1.1,2.57,1.14,3.84,1.1,2.48-1.29,3.74-1.38,2.64,1,3.9.81,2.38-1.46,3.63-1.65,2.71.75,4,.52,2.26-1.64,3.49-1.92,2.76.55,4,.22,2.13-1.8,3.34-2.18,2.79.34,4-.08,2-2,3.17-2.42,2.81.13,4-.38,1.83-2.1,3-2.66,2.81-.08,3.93-.67,1.67-2.24,2.77-2.87,2.8-.3,3.87-1,1.5-2.36,2.55-3.07,2.76-.5,3.78-1.26,1.32-2.46,2.31-3.25,2.72-.7,3.68-1.53,1.13-2.55,2.06-3.41,2.66-.91,3.56-1.81.94-2.62,1.8-3.55,2.59-1.1,3.42-2.07.74-2.68,1.53-3.68,2.49-1.29,3.25-2.31.54-2.73,1.26-3.78,2.39-1.47,3.06-2.55.34-2.77,1-3.87,2.28-1.64,2.87-2.76.13-2.79.68-3.93,2.15-1.81,2.66-3-.09-2.78.38-4,2-2,2.42-3.17-.3-2.77.08-4,1.85-2.11,2.18-3.34-.51-2.74-.22-4,1.68-2.24,1.92-3.49-.71-2.69-.52-4,1.51-2.37,1.65-3.63-.91-2.63-.81-3.91,1.33-2.46,1.37-3.74-1.1-2.56-1.1-3.83,1.15-2.57,1.1-3.84-1.28-2.48-1.37-3.74.95-2.64.81-3.9-1.47-2.38-1.65-3.63.75-2.71.52-4-1.64-2.26-1.92-3.49a2.86,2.86,0,0,1-.05-.83c-70.4,60-158,55.37-197.89,49.16a2.46,2.46,0,0,0,.07.77c.33,1.23,1.8,2.13,2.18,3.34s-.34,2.79.08,4,2,2,2.42,3.16-.13,2.81.38,4,2.1,1.84,2.66,3,.08,2.81.67,3.93,2.24,1.67,2.87,2.77.3,2.79,1,3.86,2.36,1.5,3.07,2.55.5,2.76,1.26,3.79,2.46,1.31,3.25,2.31.7,2.71,1.53,3.68,2.55,1.13,3.41,2.06.91,2.66,1.81,3.56,2.62.93,3.55,1.8,1.1,2.58,2.07,3.41,2.68.74,3.68,1.53,1.29,2.5,2.31,3.25,2.73.54,3.78,1.26,1.47,2.39,2.55,3.07,2.77.33,3.87,1,1.64,2.27,2.76,2.87,2.79.12,3.93.68,1.81,2.14,3,2.65,2.78-.09,4,.38,2,2,3.17,2.42,2.77-.29,4,.08,2.11,1.85,3.34,2.18,2.74-.5,4-.22,2.25,1.68,3.5,1.92,2.69-.71,3.95-.52,2.37,1.51,3.63,1.65S228.46,299.56,229.74,299.65Z",
    style: {
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppreciationBro);
export default __webpack_public_path__ + "static/media/Appreciation-bro.65dcd386391e6b93720c9a6cdefdf419.svg";
export { ForwardRef as ReactComponent };